import { useEffect, useRef } from "react";
import { toast } from "sonner";

/**
 * Hook for showing API token warning toast
 * Only shows once per session when token is missing
 */
export const useApiTokenToast = (
  apiToken?: string,
  user?: any,
  isApiTokenLoading?: boolean,
) => {
  const toastShownRef = useRef(false);

  useEffect(() => {
    if (!apiToken && !toastShownRef.current && user && !isApiTokenLoading) {
      toast.error("No API token found");
      toastShownRef.current = true;
    }
  }, [apiToken, user, isApiTokenLoading]);

  return { toastShownRef };
};
